import React from "react";
import { KendoGrid } from "../../Kendo/kendo_grid";
import { CorebaseURL } from "../../Util/axios_core_helper";

const RegisteredVendorMobile = () => {
  return (
    <>
      {/* <div className="page-header">
        <div className="row">
          <div className="col-sm-12">
            <h3 className="page-title">Registered Vendor Mobile</h3>
            <ul className="breadcrumb">
              <li className="breadcrumb-item">
                <a>Configuration</a>
              </li>
              <li className="breadcrumb-item active">
                Registered Vendor Mobile
              </li>
            </ul>
          </div>
        </div>
      </div> */}

      <div className="card bg-white">
        <div className="card-body">
          <div className="col-auto ms-auto">
            <div className="row">
              <div className="col-sm-6"></div>
              <div className="col-auto float-end ms-auto">
                <div className="d-flex justify-content-end mb-2"></div>
              </div>
            </div>

            <div>
              <KendoGrid
                name={"RegisteredVendorMob"}
                url={CorebaseURL + "PreferedVendors/GetRegisteredVendorMobile"}
                schema={{}}
                columns={[
                  {
                    field: "vendorId",
                    filterable: false,
                    hidden: true,
                  },
                  {
                    field: "vendorName",
                    title: "Vendor Name",
                    width: 150,
                  },

                  {
                    field: "vendorEmail",
                    title: "Email ID",
                    width: 300,
                  },
                  {
                    field: "vendorMobileNumber",
                    title: "Contact No",
                    width: 300,
                  },
                  {
                    field: "vendorTypeName",
                    title: "Vendor Type",
                    width: 300,
                  },
                ]}
                showOptions={false}
                scrollable={true}
                width={"auto"}
                height={"60vh"}
                disableExportExcel={true}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default RegisteredVendorMobile;
